import React from 'react';
import BtnWrap from './BtnWrap';

const BtnText = (props) => {
  return (
    <div className = {`BtnText ${props.className}`}>
      <BtnWrap {...props} > 
        <p>{props.text}</p>
      </BtnWrap>  
    </div>
  );

}

export default BtnText;